var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { t } from "../../I18N";

import { loadMoreReferences } from "../../ConnectionsList/actions/actions";

export const LoadMoreRelationshipsButton = ({
  totalHubs,
  requestedHubs,
  action,
  loadMoreAmmount
}) => {
  if (requestedHubs < totalHubs) {
    const actionFunction = () => {
      action(requestedHubs + loadMoreAmmount);
    };

    let loadMoreAmmountDisplay = loadMoreAmmount;

    const hubsLeft = totalHubs - requestedHubs;
    if (hubsLeft < loadMoreAmmount) {
      loadMoreAmmountDisplay = hubsLeft;
    }

    return (/*#__PURE__*/
      _jsx("div", { className: "text-center" }, void 0, /*#__PURE__*/
      _jsx("p", { className: "col-sm-12 text-center documents-counter" }, void 0, /*#__PURE__*/
      _jsx("b", {}, void 0, requestedHubs), " ", t('System', 'of'), " ", /*#__PURE__*/_jsx("b", {}, void 0, totalHubs), " ", t('System', 'hubs')
      ), /*#__PURE__*/
      _jsx("button", { onClick: actionFunction, className: "btn btn-default btn-load-more" }, void 0,
      `${loadMoreAmmountDisplay}`, " ", t('System', 'x more')
      )
      ));

  }

  return null;
};








export const mapStateToProps = ({ relationships }) => ({
  totalHubs: relationships.list.searchResults.get('totalHubs'),
  requestedHubs: relationships.list.searchResults.get('requestedHubs'),
  loadMoreAmmount: 10
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      action: loadMoreReferences
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoadMoreRelationshipsButton);